import { TDispatchFunc, IDispatchToProps } from '../types';

export const singleMapStateToProps = (state: any, props: IDispatchToProps) => {
  const { opinionMarketingFilter } = state;
  const { valueKeys, instanceId } = props;
  const realValue = opinionMarketingFilter?.[instanceId as string] || {};
  return {
    ...props,
    value: realValue?.[valueKeys as string],
    filterValue: realValue,
  };
};

export const singleMergeProps = (
  dispatch: TDispatchFunc,
  ownProps: IDispatchToProps,
) => {
  const { valueKeys, instanceId } = ownProps;

  return {
    change: (value: string) => {
      dispatch({
        type: 'opinionMarketingFilter/UPDATE_FILTER',
        payload: { [valueKeys]: value },
        instanceId,
      });
    },
  };
};

export const checkboxMergeProps = (
  dispatch: TDispatchFunc,
  ownProps: IDispatchToProps,
) => {
  const { valueKeys, instanceId } = ownProps;

  return {
    change: (value: boolean) => {
      dispatch({
        type: 'opinionMarketingFilter/UPDATE_FILTER',
        payload: { [valueKeys]: value },
        instanceId,
      });
    },
  };
};
